import React from 'react';
import { ChevronRight } from 'lucide-react';
import './ShareButton.css';

const ShareButton = ({
  onClick,
  disabled,
  loading,
  text = "JUMP BACK IN",
  className = ""
}) => {
  return (
    <div className={`button-container ${className}`}>
      <div 
        className={`button-content ${disabled ? 'disabled' : ''}`}
        onClick={!disabled && !loading ? onClick : undefined}
      >
        <span className="text">
          {loading ? 'Loading...' : text}
        </span>
        <ChevronRight className="continue-icon" size={24} />
      </div>
    </div>
  );
};

export default ShareButton;